export const statuses = [
  { id: 4, name: 'In Use' },
  { id: 3, name: 'Full' },
  { id: 2, name: 'Approaching Capacity' },
  { id: 1, name: 'Available' },
];
